import React from 'react';
import "../css/bootstrap.css"
import "../css/app.css"

export const Blog = () => {
    return(
        <div className="container black">
                <div className="container black projects">
                <hr></hr>
                <h1 className="projecttitle">Coming Soon :)</h1>
            </div>
        </div>
    )
}